import PropTypes from 'prop-types';
import { lazy, useCallback } from "react";

const Checkbox = lazy(() => import("../formsUi/checkBox/CheckBox"));

const FormCheckBoxControls = ({
    id,
    targetId,
    name,
    value,
    onChange,
    labelName,
    dataField,
    formSetting,
    fieldSetting,
    overRideProps,
    // onActionChange,
}) => {

    const handleCheckboxChange = useCallback((dataField, value) => {
        if (onChange) {
            onChange(dataField, value);
        }
    }, [onChange]);

    return (
        <div className="input-field-sec">
            {fieldSetting?.subTitle && (
                <div className="section-title">
                    <h5>{fieldSetting.subTitle}</h5>
                </div>
            )}
            <div className="checkbox-label-part" id={targetId}>
                <Checkbox
                    id={id}
                    name={name}
                    label={labelName}
                    checked={value === 'true' || value === true}
                    isDisable={formSetting?.isViewOnly || (overRideProps?.isDisable !== undefined ? overRideProps?.isDisable : fieldSetting?.isDisable) || false}
                    dataField={dataField}
                    onChange={handleCheckboxChange}
                    {...fieldSetting}
                />
            </div>
        </div>
    );
};

FormCheckBoxControls.propTypes = {
    id: PropTypes.string,
    targetId: PropTypes.string,
    name: PropTypes.string.isRequired,
    keyId: PropTypes.string,
    value: PropTypes.oneOfType([PropTypes.string, PropTypes.bool]),
    onChange: PropTypes.func.isRequired,
    labelName: PropTypes.string,
    dataField: PropTypes.string.isRequired,
    onActionChange: PropTypes.func,
    formSetting: PropTypes.shape({
        isViewOnly: PropTypes.bool,
    }),
    overRideProps: PropTypes.shape({
        isDisable: PropTypes.bool,
    }),
    fieldSetting: PropTypes.shape({
        isDisable: PropTypes.bool,
        subTitle: PropTypes.string,
        isFormControl: PropTypes.bool,
        inputInfoConfig: PropTypes.object,
    }),
};

export default FormCheckBoxControls;
